// @ts-check

import React, { useCallback, useImperativeHandle, useRef, useState } from 'react';
import { Overlay, Popover } from "react-bootstrap";



/**
 * @param {{
*   refOverlayTarget: React.RefObject<HTMLDivElement>,
*   children: React.ReactNode,
* }} props
*
* @param {React.ForwardedRef<HTMLDivElement>} ref
*
*/
let WeekPickerOverlayImpl = (props, ref) => {

  let [isOpen, setIsOpen] = useState(/** @type {boolean} */(false));
  
  
  const targetRef = useRef(null);

  const open = useCallback(() => {
    setIsOpen(true)
  }, []);
  
  const close = useCallback(() => {
    setIsOpen(false)
  }, []);
  
  const toggle = useCallback(() => {
    setIsOpen((v) => !v)
  }, []);
  
  
  

  // @ts-ignore
  useImperativeHandle(ref, () => ({ open, close, toggle, targetRef }), [
    open,
    close,
    toggle,
  ]);
  

  return (

    <div className='week-picker-popover-container'>
      <Overlay
        target={props.refOverlayTarget.current}
        show={isOpen}
        placement='bottom'
        rootClose={true}
        onHide={() => setIsOpen(false)}
      >
        <Popover className={'pl-popover pl-week-picker-popover'} placement='top'>
          <div className='popover-content'>
            <div className='popover-component'>

              {props.children}

            </div>
          </div>
        </Popover>

      </Overlay>
    </div>

  );
}

const WeekPickerOverlay = React.forwardRef(WeekPickerOverlayImpl);
export default WeekPickerOverlay;

